<template>
  <div
    class="d-flex justify-content-between"
    style="align-items:center"
  >
    <v-text-field
      label="Doğrulama Kodu"
      :rules="required ? [$rules.empty('Doğrulama Kodu')] : ''"
      :required="required"
      style="margin-right:5px"
      maxLength="4"
      v-on:change="handleVerification"
    >
    </v-text-field>
    <v-btn
      color="success"
      @click="verificationOnClick"
      style="margin-bottom:6px"
      large
      v-text="button_text"
      :disabled="timerEnabled"
    >
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SmsVerification",
  components: {},

  data: () => ({
    timerCount: 16,
    button_text: "SMS Kodu Al",
    timerEnabled: false,
    hash: "",
  }),

  methods: {
    ...mapActions({ send: "asyncSender" }),
    verificationOnClick() {
      this.timerEnabled = true;
      this.send({
        route: "sms/verification/send",
        data: { phone: this.phone },
      }).then((res) => {
        this.hash = res.data.hash;
      });
    },
    handleVerification(val) {
      let data = {
        key: val,
      };

      if (this.hash) {
        data.hash = this.hash;
      }

      this.$emit("emitVerification", data);
    },
  },

  watch: {
    timerEnabled(value) {
      if (value) {
        this.timerCount--;
      }
    },

    timerCount: {
      handler(value) {
        if (value >= 0 && this.timerEnabled) {
          setTimeout(() => {
            let c = this.timerCount--;
            this.button_text = "Tekrar Deneyin (" + c + ")";
          }, 1000);
        } else {
          this.button_text = "SMS Kodu Al";
          this.timerEnabled = false;
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  props: {
    phone: {
      type: String,
      required: true,
    },
    required:{
      type: Boolean,
      required:false,
      default:true,
    }
  },
};
</script>
